import { Checkbox, FormControl, FormControlLabel } from "@mui/material";

import { useOnboardingContext } from "@/common/contexts/onboarding";

export function OnboardingIsShowOnLaunchInput() {
  const onboardingContext = useOnboardingContext();

  return (
    <FormControl>
      <FormControlLabel
        sx={{
          pr: 1,
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: "divider",
          borderRadius: (th) => th.shapeCustom.borderRadiusButton,
        }}
        label='Show welcome pop-up on next login'
        control={
          <Checkbox
            checked={onboardingContext.onboarding?.isShowOnLaunch ?? false}
            onChange={() => {
              onboardingContext.toggleIsShowOnLaunch();
            }}
          />
        }
      />
    </FormControl>
  );
}
